import DefaultUptimeTheme from 'component/theme/defaultTheme';
import { useTheme } from 'styled-components';
import { Color, Status } from '../types';

export const useProductEyebrow = (eyebrowText: string, locale?: Record<string, string>) => {
  const theme = useTheme() as unknown as typeof DefaultUptimeTheme;

  const mapEyebrowColor = (): Color => {
    const defaultColor = theme.uptimeColors.deviceCardEyebrow.inUse;

    const mappedObject: Record<string, Color> = {
      [Status.APPROVAL_REQ]: defaultColor,
      [Status.EXCP_APPROVAL_REQ]: theme.uptimeColors.deviceCardEyebrow.exception,
      [Status.EXCEPTION_REQUIRED]: theme.uptimeColors.deviceCardEyebrow.exception,
    };

    return mappedObject[eyebrowText.toUpperCase()] || defaultColor;
  };

  const mapEyebrowText = (): string => {
    if (!locale) return eyebrowText;
    if (eyebrowText in Status) {
      return locale[eyebrowText] || eyebrowText;
    }
    return '';
  };

  return {
    color: mapEyebrowColor(),
    text: mapEyebrowText().toUpperCase(),
  };
};
